export default {
  badge: 'Distintivo',
  open: 'Abrir',
  close: 'Fechar',
  dismiss: 'Dispensar',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Cancelar',
  },
  dataIterator: {
    noResultsText: 'Nenhum dado encontrado',
    loadingText: 'Carregando itens...',
  },
  dataTable: {
    itemsPerPageText: 'Linhas por página:',
    ariaLabel: {
      sortDescending: 'Ordenado decrescente.',
      sortAscending: 'Ordenado crescente.',
      sortNone: 'Não ordenado.',
      activateNone: 'Ative para remover a ordenação.',
      activateDescending: 'Ative para ordenar decrescente.',
      activateAscending: 'Ative para ordenar crescente.',
      selectRow: 'Selecionar linha',
      selectAll: 'Selecionar tudo',
      selectGroup: 'Selecionar grupo',
    },
    sortBy: 'Ordenar por',
  },
  dataFooter: {
    itemsPerPageText: 'Itens por página:',
    itemsPerPageAll: 'Todos',
    nextPage: 'Próxima página',
    prevPage: 'Página anterior',
    firstPage: 'Primeira página',
    lastPage: 'Última página',
    pageText: '{0}-{1} de {2}',
  },
  dateRangeInput: {
    divider: 'até',
  },
  monthPicker: {
    title: 'Selecionar mês',
    itemsSelected: '{0} selecionados',
    header: 'Digite o mês',
    range: {
      title: 'Digite os meses',
    },
    ariaLabel: {
      previousYear: 'Ano anterior',
      nextYear: 'Próximo ano',
      selectYear: 'Selecionar ano',
      currentMonth: 'Mês atual, {0}',
    },
  },
  datePicker: {
    itemsSelected: '{0} selecionados',
    range: {
      title: 'Selecione as datas',
      header: 'Digite as datas',
    },
    title: 'Selecione a data',
    header: 'Digite a data',
    input: {
      placeholder: 'Insira a data',
    },
    ariaLabel: {
      previousMonth: 'Mês anterior',
      nextMonth: 'Próximo mês',
      selectYear: 'Selecionar ano',
      previousYear: 'Ano anterior',
      nextYear: 'Próximo ano',
      selectMonth: 'Selecionar mês',
      selectDate: '{0}',
      currentDate: 'Hoje, {0}',
    },
  },
  noDataText: 'Não há dados disponíveis',
  carousel: {
    prev: 'Visão anterior',
    next: 'Próxima visão',
    ariaLabel: {
      delimiter: 'Slide {0} de {1} do carrossel',
    },
  },
  calendar: {
    moreEvents: 'Mais {0}',
    today: 'Hoje',
  },
  heatmap: {
    less: 'Menos',
    more: 'Mais',
  },
  input: {
    clear: 'Limpar {0}',
    prependAction: '{0} ação antes',
    appendAction: '{0} ação depois',
    otp: 'Por favor, insira o caractere OTP {0}',
  },
  fileInput: {
    counter: '{0} arquivo(s)',
    counterSize: '{0} arquivo(s) ({1} no total)',
  },
  fileUpload: {
    title: 'Arraste e solte os arquivos aqui',
    divider: 'ou',
    browse: 'Procurar arquivos',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Selecione o horário',
    hour: 'Hora',
    minute: 'Minuto',
    second: 'Segundos',
    notAllowed: 'O valor não é permitido',
  },
  pagination: {
    ariaLabel: {
      root: 'Navegação de paginação',
      next: 'Próxima página',
      previous: 'Página anterior',
      page: 'Ir à página {0}',
      currentPage: 'Página atual, página {0}',
      first: 'Primeira página',
      last: 'Última página',
    },
  },
  stepper: {
    next: 'Próximo',
    prev: 'Anterior',
  },
  rating: {
    ariaLabel: {
      item: 'Avaliação {0} de {1}',
    },
  },
  loading: 'Carregando...',
  infiniteScroll: {
    loadMore: 'Carregar mais',
    empty: 'Não há mais dados',
  },
  rules: {
    required: 'Este campo é obrigatório',
    email: 'Por favor, insira um e-mail válido',
    number: 'Este campo só pode conter números',
    integer: 'Este campo só pode conter valores inteiros',
    capital: 'Este campo só pode conter letras maiúsculas',
    maxLength: 'Você deve inserir no máximo {0} caracteres',
    minLength: 'Você deve inserir no mínimo {0} caracteres',
    strictLength: 'O comprimento do campo inserido é inválido',
    exclude: 'O caractere {0} não é permitido',
    notEmpty: 'Por favor, escolha pelo menos um valor',
    pattern: 'Formato inválido',
  },
  command: {
    search: 'Digite um comando ou pesquise...',
  },
  hotkey: {
    then: 'então',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Seta para cima',
    downArrow: 'Seta para baixo',
    leftArrow: 'Seta para a esquerda',
    rightArrow: 'Seta para a direita',
    backspace: 'Backspace',
    space: 'Espaço',
    plus: 'mais',
    shortcut: 'Atalho de teclado: {0}',
    or: 'ou',
  },
  video: {
    play: 'Reproduzir',
    pause: 'Pausar',
    seek: 'Buscar',
    volume: 'Volume',
    showVolume: 'Mostrar controle de volume',
    mute: 'Silenciar',
    unmute: 'Ativar som',
    enterFullscreen: 'Tela cheia',
    exitFullscreen: 'Sair da tela cheia',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Selecionar cor da tela',
      hueSlider: 'Matiz',
      alphaSlider: 'Alfa',
      redInput: 'Vermelho',
      greenInput: 'Verde',
      blueInput: 'Azul',
      alphaInput: 'Alfa',
      hueInput: 'Matiz',
      saturationInput: 'Saturação',
      lightnessInput: 'Luminosidade',
      hexInput: 'Valor HEX',
      hexaInput: 'HEX com valor alfa',
      changeFormat: 'Alterar formato da cor',
    },
  },
}
